import type { Transition, Variants } from 'framer-motion';

type SpringName = 'snappy' | 'bouncy' | 'smooth' | 'heavy' | 'sheet';

export const spring: Record<SpringName, Transition> = {
  snappy: { type: 'spring', stiffness: 500, damping: 30, mass: 0.8 },
  bouncy: { type: 'spring', stiffness: 400, damping: 18, mass: 1 },
  smooth: { type: 'spring', stiffness: 260, damping: 26, mass: 1 },
  heavy: { type: 'spring', stiffness: 200, damping: 30, mass: 1.4 },
  sheet: { type: 'spring', stiffness: 420, damping: 40, mass: 0.9 },
};

export const easeOut = [0.23, 1, 0.32, 1] as const;

export const stagger: Variants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.06, delayChildren: 0.05 } },
};

export const rise: Variants = {
  hidden: { opacity: 0, y: 18 },
  show: { opacity: 1, y: 0, transition: spring.smooth },
};
